export default __webpack_public_path__ + "static/media/NL_parcours_2_carte_2.0a1ff915.png";